import { useQuery } from '@apollo/client';
import {
  ChargeVerificationConfigQuery,
  ChargeVerificationConfigQueryVariables,
} from 'graphql-query-contracts';
import { chargeVerificationConfigQuery } from 'graphql-queries';
import { useSrChargeVerificationEnabled } from 'react-hooks';

import { ChargeVerificationConfigLoadError } from './chargeVerificationConfigLoadError';

type Params = {
  channelId: string | undefined;
  isBillingTabAvailable: boolean;
};

type ChargeVerificationConfigResult = {
  savedValue: boolean | undefined;
  loading: boolean;
  error: ChargeVerificationConfigLoadError | undefined;
};

export function useChargeVerificationConfig({
  channelId,
  isBillingTabAvailable,
}: Params): ChargeVerificationConfigResult {
  const isFlagEnabled = useSrChargeVerificationEnabled();
  const shouldFetch =
    isBillingTabAvailable && isFlagEnabled && channelId !== undefined;
  const {
    data,
    loading,
    error: queryError,
  } = useQuery<
    ChargeVerificationConfigQuery,
    ChargeVerificationConfigQueryVariables
  >(chargeVerificationConfigQuery, {
    variables: { channelId },
    skip: !shouldFetch,
  });

  if (queryError) {
    const loadError = new ChargeVerificationConfigLoadError(queryError);

    return { savedValue: undefined, loading, error: loadError };
  }

  return {
    savedValue: data?.chargeVerificationConfig.chargeVerificationEnabled,
    loading,
    error: undefined,
  };
}
